<div class="card">
    <div class="card-body card-header-border">
        <div class="grid-header">
            <h5>{{ _i18n._11112_ADD_METRICS_TO_FOCUS | translate }}</h5>
            <ul class="legend">
                <li>
                    <p>{{ _i18n._7489_UNCOACHED | translate }}</p>
                    <cmps-icon
                        class="cgtsst-uncoached"
                        svgIcon="alert-circle"
                    ></cmps-icon>
                </li>
                <li>
                    <p>{{ _i18n._7488_COACHED | translate }}</p>
                    <cmps-icon
                        class="cgtsst-coached"
                        svgIcon="alert-circle"
                    ></cmps-icon>
                </li>
                <li>
                    <p>{{ _i18n._7436_NON_OPPORTUNITY | translate }}</p>
                    <cmps-icon
                        class="cgtsst-non-opportunity"
                        svgIcon="alert-circle"
                    ></cmps-icon>
                </li>
                <li>
                    <p>{{ _i18n._9617_ON_SCORECARD | translate }}</p>
                    <cmps-icon
                        class="cgtsst-on-scorecard"
                        svgIcon="check-circle"
                    ></cmps-icon>
                </li>
            </ul>
        </div>
        <div class="grid-body">
            <div *ngIf="!_showGrid">
                {{
                    _i18n._11113_YOU_MUST_SELECT_METRIC_AND_FOCUS_TO_SET_GOALS
                        | translate
                }}
            </div>
            <div *ngIf="_showGrid">
                <reusable-grid
                    [rendererOptions]="gridData.rendererOpts"
                    [selectTemplate]="_selectTpl"
                    [rowsTop]="gridData.gridRowsTop"
                    [rows]="gridData.rows"
                    [sortDefs]="gridData.sortDefs"
                    selectType="multi"
                >
                    <ng-template
                        gridContent
                        data-type="grid"
                    >
                        <div></div>
                    </ng-template>

                    <ng-template
                        gridContent
                        data-type="row"
                        data-id="header"
                    >
                        <div></div>
                    </ng-template>

                    <ng-template
                        gridContent
                        data-type="row"
                        data-id="content"
                    >
                        <div></div>
                    </ng-template>

                    <ng-template
                        gridContent
                        data-type="cell"
                        data-id="header"
                        let-c="c"
                    >
                        <div [ngSwitch]="c.id">
                            <div *ngSwitchCase="_ColumnID.METRIC">
                                {{ _i18n._713_METRIC | translate }}
                            </div>
                            <div *ngSwitchCase="_ColumnID.OA">
                                {{ _i18n._7463_OA | translate }}
                            </div>
                            <div *ngSwitchCase="_ColumnID.ON_SCORECARD">
                                {{ _i18n._9617_ON_SCORECARD | translate }}
                            </div>
                            <div *ngSwitchCase="_ColumnID.ACTUAL">
                                {{ _i18n._725_ACTUAL | translate }}
                            </div>
                            <div *ngSwitchCase="_ColumnID.TARGET">
                                {{ _i18n._726_TARGET | translate }}
                            </div>
                            <div
                                *ngSwitchCase="
                                    _ColumnID.PROJECTED_15_DAY_IMPROVEMENT
                                "
                            >
                                {{ _i18n._11099_15_DAY_FORECAST | translate }}
                            </div>
                            <div
                                *ngSwitchCase="
                                    _ColumnID.PROJECTED_30_DAY_IMPROVEMENT
                                "
                            >
                                {{ _i18n._11100_30_DAY_FORECAST | translate }}
                            </div>
                            <div
                                *ngSwitchCase="
                                    _ColumnID.PROJECTED_60_DAY_IMPROVEMENT
                                "
                            >
                                {{ _i18n._11101_60_DAY_FORECAST | translate }}
                            </div>
                        </div>
                    </ng-template>

                    <ng-template
                        gridContent
                        data-type="cell"
                        data-id="content"
                        let-c="c"
                        let-l="l"
                        let-r="r"
                        let-ctx="ctx"
                    >
                        <div
                            [ngSwitch]="c.id"
                            [class.row-checked]="ctx.checked"
                        >
                            <div
                                *ngSwitchCase="_ColumnID.METRIC"
                                class="cgtsst-grid-other"
                                (click)="_selectCell(r.def.id, null)"
                            >
                                <cmps-checkbox
                                    [variant]="ctx.checkboxVariant"
                                    [checked]="ctx.checked"
                                    (click)="_selectCell(r.def.id, null)"
                                >
                                    <reusable-grid-text
                                        [text]="ctx.metric"
                                        [resizeSubject]="ctx.resizeSubject"
                                    ></reusable-grid-text>
                                </cmps-checkbox>
                            </div>
                            <div
                                *ngSwitchCase="_ColumnID.OA"
                                class="cgtsst-grid-other"
                                (click)="_selectCell(r.def.id, null)"
                            >
                                <cmps-icon
                                    [class.cgtsst-non-opportunity]="
                                        ctx.oa === _CoachingType.NON_OPPORTUNITY
                                    "
                                    [class.cgtsst-coached]="
                                        ctx.oa === _CoachingType.COACHED
                                    "
                                    [class.cgtsst-uncoached]="
                                        ctx.oa === _CoachingType.UNCOACHED
                                    "
                                    svgIcon="alert-circle"
                                    [cmpsTooltipTrigger]="
                                        _getCoachableTranslationText(ctx.oa)
                                    "
                                    trigger="hover"
                                    *ngIf="ctx.oa != null"
                                ></cmps-icon>
                            </div>
                            <div
                                *ngSwitchCase="_ColumnID.ON_SCORECARD"
                                class="cgtsst-grid-other"
                                (click)="_selectCell(r.def.id, null)"
                            >
                                <cmps-icon
                                    [cmpsTooltipTrigger]="
                                        (ctx.isInScorecard
                                            ? _i18n._11091_METRIC_IS_CONFIGURED_ON_PERFORMER_S_SCORECARD
                                            : ''
                                        ) | translate
                                    "
                                    trigger="hover"
                                    class="cgtsst-on-scorecard"
                                    svgIcon="check-circle"
                                    *ngIf="ctx.isInScorecard"
                                ></cmps-icon>
                            </div>
                            <div
                                *ngSwitchCase="_ColumnID.ACTUAL"
                                class="cgtsst-grid-other"
                                (click)="_selectCell(r.def.id, null)"
                            >
                                <reusable-grid-text
                                    class="text-center"
                                    [text]="ctx?.actual | cmpsNumber: '1.2-2'"
                                    [resizeSubject]="ctx.resizeSubject"
                                ></reusable-grid-text>
                            </div>
                            <div
                                *ngSwitchCase="_ColumnID.TARGET"
                                class="cgtsst-grid-other"
                                (click)="_selectCell(r.def.id, null)"
                            >
                                <reusable-grid-text
                                    class="text-center"
                                    [text]="ctx?.target | cmpsNumber: '1.2-2'"
                                    [resizeSubject]="ctx.resizeSubject"
                                ></reusable-grid-text>
                            </div>
                            <div
                                *ngSwitchCase="
                                    _ColumnID.PROJECTED_15_DAY_IMPROVEMENT
                                "
                                [class.selected-cell]="
                                    _isProjectionCellSelected(
                                        gridData.selection.projectionEvalCol,
                                        r.def.id,
                                        _ProjectionEvalId.DAY_15
                                    )
                                "
                                (click)="
                                    _selectCell(
                                        r.def.id,
                                        _ProjectionEvalId.DAY_15
                                    )
                                "
                            >
                                <reusable-grid-text
                                    class="text-center"
                                    [text]="
                                        ctx?.projected15
                                            ? (ctx?.projected15
                                              | cmpsPercent: '1.0-2')
                                            : '--'
                                    "
                                    [resizeSubject]="ctx.resizeSubject"
                                ></reusable-grid-text>
                            </div>
                            <div
                                *ngSwitchCase="
                                    _ColumnID.PROJECTED_30_DAY_IMPROVEMENT
                                "
                                [class.selected-cell]="
                                    _isProjectionCellSelected(
                                        gridData.selection.projectionEvalCol,
                                        r.def.id,
                                        _ProjectionEvalId.DAY_30
                                    )
                                "
                                (click)="
                                    _selectCell(
                                        r.def.id,
                                        _ProjectionEvalId.DAY_30
                                    )
                                "
                            >
                                <reusable-grid-text
                                    class="text-center"
                                    [text]="
                                        ctx?.projected30
                                            ? (ctx?.projected30
                                              | cmpsPercent: '1.0-2')
                                            : '--'
                                    "
                                    [resizeSubject]="ctx.resizeSubject"
                                ></reusable-grid-text>
                            </div>
                            <div
                                *ngSwitchCase="
                                    _ColumnID.PROJECTED_60_DAY_IMPROVEMENT
                                "
                                [class.selected-cell]="
                                    _isProjectionCellSelected(
                                        gridData.selection.projectionEvalCol,
                                        r.def.id,
                                        _ProjectionEvalId.DAY_60
                                    )
                                "
                                (click)="
                                    _selectCell(
                                        r.def.id,
                                        _ProjectionEvalId.DAY_60
                                    )
                                "
                            >
                                <reusable-grid-text
                                    class="text-center"
                                    [text]="
                                        ctx?.projected60
                                            ? (ctx?.projected60
                                              | cmpsPercent: '1.0-2')
                                            : '--'
                                    "
                                    [resizeSubject]="ctx.resizeSubject"
                                ></reusable-grid-text>
                            </div>
                        </div>
                    </ng-template>
                </reusable-grid>
            </div>
        </div>

        <div
            *ngIf="
                _showGrid &&
                gridData?.selection?.goals &&
                gridData.selection.goals.length > 0
            "
            class="selected-goals-area"
        >
            <h5>{{ _i18n._11114_SELECTED_GOALS | translate }}</h5>
            <div
                *ngFor="let goal of gridData.selection.goals"
                class="goal-area"
            >
                <div [attr.data-goal-id]="goal.metricId">
                    <div class="goal-area-header p-2">
                        <h4>{{ goal.metric }}</h4>
                    </div>
                    <div
                        class="shared-goal-warning"
                        *ngIf="_activeGoalMetricIds[goal.metricId] != null"
                    >
                        <cmps-icon svgIcon="alert-box-outline"></cmps-icon>
                        <p class="goal-warning">
                            {{ _i18n._11116_SHARED_GOAL_WARNING | translate }}
                        </p>
                    </div>
                    <div
                        *ngIf="_forms[goal.metricId] != null"
                        class="goal-area-body"
                        [formGroup]="_forms[goal.metricId].form"
                    >
                        <div class="goal-information">
                            <div class="form-field">
                                <label>{{
                                    _i18n._4106_CURRENT_ACTUAL | translate
                                }}</label>
                                <input
                                    class="form-control"
                                    type="number"
                                    placeholder="-"
                                    readonly
                                    [formControlName]="
                                        _FormFields.CURRENT_ACTUAL.name
                                    "
                                />
                            </div>
                            <div class="form-field">
                                <label>{{
                                    _i18n._9779_EXPECTED_ACHIEVEMENT_DATE
                                        | translate
                                }}</label>
                                <div class="form-control date-picker">
                                    <input
                                        placeholder="MM-DD-YYYY"
                                        readonly
                                        ngbDatepicker
                                        [minDate]="_minDate"
                                        [formControlName]="
                                            _FormFields
                                                .EXPECTED_ACHIEVEMENT_DATE.name
                                        "
                                        #dp="ngbDatepicker"
                                    />
                                    <button
                                        type="button"
                                        class="btn btn-secondary date-selector-btn"
                                        aria-label="Toggle date picker"
                                        [attr.aria-expanded]="dp.isOpen()"
                                        (click)="dp.toggle()"
                                    >
                                        <cmps-icon
                                            svgIcon="calendar"
                                        ></cmps-icon>
                                    </button>
                                </div>
                            </div>
                            <div class="form-field">
                                <label>{{
                                    _i18n._11115_PERCENT_GAP_TO_TARGET
                                        | translate
                                }}</label>
                                <input
                                    class="form-control"
                                    type="number"
                                    readonly
                                    placeholder="%"
                                    [formControlName]="
                                        _FormFields.PERCENT_GAP_TO_TARGET.name
                                    "
                                />
                            </div>
                            <div class="form-field">
                                <label>{{
                                    _i18n._9431__IMPROVEMENT_EXPECTED
                                        | translate
                                }}</label>
                                <input
                                    class="form-control"
                                    type="number"
                                    placeholder="%"
                                    twoDecimalInput
                                    [formControlName]="
                                        _FormFields.PERCENT_IMPROVEMENT_EXPECTED
                                            .name
                                    "
                                />
                            </div>
                            <div class="form-field">
                                <label>{{
                                    _i18n._9432_GOAL_VALUE | translate
                                }}</label>
                                <input
                                    class="form-control"
                                    type="number"
                                    placeholder="-"
                                    twoDecimalInput
                                    [formControlName]="
                                        _FormFields.GOAL_VALUE.name
                                    "
                                />
                            </div>
                            <div class="form-field">
                                <label>{{
                                    _i18n._9433_START___TO_GOAL | translate
                                }}</label>
                                <input
                                    class="form-control"
                                    type="number"
                                    readonly
                                    placeholder="%"
                                    twoDecimalInput
                                    [formControlName]="
                                        _FormFields.START_PERCENT_TO_GOAL.name
                                    "
                                />
                            </div>
                            <div class="label-field">
                                <p>
                                    {{
                                        _i18n._9434_DAYS_TO_ACHIEVEMENT
                                            | translate
                                    }}:
                                </p>
                                <p
                                    [style.color]="
                                        _daysToAchievement?.[goal.metricId]
                                            ?.daysToAchievementColor
                                    "
                                >
                                    {{
                                        _daysToAchievement?.[goal.metricId]
                                            ?.daysToAchievement
                                    }}
                                </p>
                            </div>
                        </div>
                        <div class="trend-chart-wrapper">
                            <div
                                *ngIf="_goalChart[goal.metricId] != null"
                                class="trend-chart"
                            >
                                <goal-chart-commitment
                                    [activeMetric]="
                                        _goalChart[goal.metricId].activeMetric
                                    "
                                    [periodType]="_PeriodType.ROLLING_30"
                                    [data]="_goalChart[goal.metricId].data"
                                    [graphType]="_GraphType.TREND"
                                    [showEmptyGraph]="
                                        _goalChart[goal.metricId].showEmptyGraph
                                    "
                                ></goal-chart-commitment>
                                <div class="legend">
                                    <div class="btn-legend">
                                        <cmps-icon
                                            class="target-line"
                                        ></cmps-icon>
                                        <span class="label-text">
                                            {{
                                                _i18n._7457_TARGET_LINE
                                                    | translate
                                            }}
                                        </span>
                                    </div>
                                    <div class="btn-legend">
                                        <cmps-icon
                                            class="actual-line"
                                        ></cmps-icon>
                                        <span class="label-text">
                                            {{
                                                _i18n._7456_ACTUAL_LINE
                                                    | translate
                                            }}
                                        </span>
                                    </div>
                                    <div class="btn-legend">
                                        <span class="goal-line"></span>
                                        <span class="label-text">
                                            {{
                                                _i18n._7458_GOAL_LINE
                                                    | translate
                                            }}
                                        </span>
                                    </div>
                                    <div class="btn-legend">
                                        <span class="sg-line"></span>
                                        <span class="label-text">
                                            {{
                                                _i18n._9480_SUPERGROUP_AVERAGE
                                                    | translate
                                            }}
                                        </span>
                                    </div>
                                    <div class="btn-legend">
                                        <cmps-icon
                                            class="dot-active"
                                            svgIcon="flag"
                                        ></cmps-icon>
                                        <span class="label-text">
                                            {{
                                                _i18n._9454_ACTIVE_GOAL
                                                    | translate
                                            }}
                                        </span>
                                    </div>
                                    <div class="btn-legend">
                                        <cmps-icon svgIcon="circle"></cmps-icon>
                                        <span class="label-text">
                                            {{
                                                _i18n._9455_HISTORIC_GOALS
                                                    | translate
                                            }}
                                        </span>
                                    </div>
                                    <div class="btn-legend">
                                        <cmps-icon
                                            class="dot"
                                            svgIcon="folder-account"
                                        ></cmps-icon>
                                        <span class="label-text">
                                            {{
                                                _i18n._9457_COMMITMENT_EVENT
                                                    | translate
                                            }}
                                        </span>
                                    </div>
                                    <div class="btn-legend">
                                        <cmps-icon
                                            class="dot-multiple"
                                            svgIcon="calendar-text"
                                        ></cmps-icon>
                                        <span class="label-text">
                                            {{
                                                _i18n._9458_MULTIPLE_COACHING_EVENTS
                                                    | translate
                                            }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
